import { OrderItem } from '@/types/order-list';
import { CellContext } from '@tanstack/react-table';

export const getIsBundleItem = (info: CellContext<OrderItem, unknown>) => {
  const rows = info.table.getRowModel().rows;
  const order = info.row.original;
  const firstRowMap = new Map<string, string>();
  rows.forEach((row) => {
    const orderNo = (row.original as OrderItem).orderNo;
    if (!firstRowMap.has(orderNo)) {
      firstRowMap.set(orderNo, row.id);
    }
  });

  const orderNo = order.orderNo;
  const firstRowId = firstRowMap.get(orderNo);

  return info.cell.row.id !== firstRowId && info.row.original.marketInfo.marketName === 'coupang';
};
